var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05546 4.05546C2.57118 3.53973 3.27065 3.25 4 3.25H11C11.4142 3.25 11.75 3.58579 11.75 4C11.75 4.41421 11.4142 4.75 11 4.75H4C3.66848 4.75 3.35054 4.8817 3.11612 5.11612C2.8817 5.35054 2.75 5.66848 2.75 6V20C2.75 20.3315 2.8817 20.6495 3.11612 20.8839C3.35054 21.1183 3.66848 21.25 4 21.25H18C18.3315 21.25 18.6495 21.1183 18.8839 20.8839C19.1183 20.6495 19.25 20.3315 19.25 20V13C19.25 12.5858 19.5858 12.25 20 12.25C20.4142 12.25 20.75 12.5858 20.75 13V20C20.75 20.7293 20.4603 21.4288 19.9445 21.9445C19.4288 22.4603 18.7293 22.75 18 22.75H4C3.27065 22.75 2.57118 22.4603 2.05546 21.9445C1.53973 21.4288 1.25 20.7293 1.25 20V6C1.25 5.27065 1.53973 4.57118 2.05546 4.05546Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8969 2.75C19.538 2.75 19.1939 2.89256 18.9401 3.14631L9.66863 12.4178L9.03078 14.9692L11.5822 14.3314L20.8537 5.05988C21.1074 4.80612 21.25 4.46196 21.25 4.1031C21.25 3.74423 21.1074 3.40007 20.8537 3.14631C20.5999 2.89256 20.2558 2.75 19.8969 2.75ZM17.8795 2.08565C18.4145 1.55059 19.1402 1.25 19.8969 1.25C20.6536 1.25 21.3793 1.55059 21.9143 2.08565C22.4494 2.62071 22.75 3.34641 22.75 4.1031C22.75 4.85978 22.4494 5.58548 21.9143 6.12054L12.496 15.5389C12.3998 15.635 12.2794 15.7032 12.1475 15.7362L8.1819 16.7276C7.92632 16.7915 7.65596 16.7166 7.46967 16.5303C7.28339 16.344 7.2085 16.0737 7.27239 15.8181L8.2638 11.8525C8.29677 11.7206 8.36496 11.6002 8.46108 11.504L17.8795 2.08565Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.87c11e78e09e654490d1b2a5d05c735b.svg";
export { ForwardRef as ReactComponent };